import React, { useState } from 'react';
import { Formik, Form } from 'formik';

import Circle from 'components/circle';
import Alert from 'components/alert';
import ErrorMessage from 'components/error-message';
import Button from 'components/button';
import Field from 'components/field';
import { PageForm } from 'components/layouts';

import { usePasswordResetRequest } from './mutations';

import schema from './schema';

import './style.css';

const initialValues = { email: '' };

const ForgotPassword = () => {
  const [success, setSuccess] = useState(false);
  const [mutate] = usePasswordResetRequest();

  const onSubmit = async (values, { setSubmitting, setStatus }) => {
    try {
      await mutate(values);
      setSuccess(true);
    } catch (e) {
      const {
        response: { data },
      } = e;
      setStatus(data.detail);
      console.error(e);
      setSubmitting(false);
    }
  };

  const title = !success ? 'Forgot Password' : 'PASSWORD RESET E-MAIL SENT';

  return (
    <>
      <Circle
        className="forgot-circle-02"
        theme="white"
        width="400px"
        angle={140}
        distance={32}
        blur={32}
      />
      <PageForm
        className="-forgot-password"
        backTo="/login"
        backToText="Log In"
        title={title}
        background={!success}
      >
        {success ? (
          <p>
            Please check your mail inbox and click the password reset e-mail.
          </p>
        ) : (
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={schema}
          >
            {({ isSubmitting, status }) => (
              <Form>
                {status ? (
                  <Alert
                    className="form-general-errors"
                    type="error"
                    message={status}
                  />
                ) : null}

                <Circle
                  className="forgot-circle-01"
                  theme="white"
                  width="600px"
                  angle={320}
                  distance={32}
                  blur={32}
                />

                <ErrorMessage name="email" />
                <Field
                  id="email"
                  name="email"
                  placeholder="Email"
                  type="email"
                />
                <Button
                  type="submit"
                  hierarchy="secondary"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                >
                  Next
                </Button>
              </Form>
            )}
          </Formik>
        )}
      </PageForm>
    </>
  );
};

export default ForgotPassword;
